import Vivus from 'vivus';
document.addEventListener('DOMContentLoaded', () => {
  const svg = document.getElementById('sbs_text_mask');
  const tegaki = document.getElementsByClassName('c-fv__tegaki')[0];
  if (svg) {
    tegaki.classList.add('active');
    setTimeout(() => {
      new Vivus(svg, {
        type: 'scenario-sync',
        duration: 2,
        forceRender: false,
        animTimingFunction: Vivus.EASE
      })
    }, 800)
  }
})